<template>
  <div>
    <Form ref="editModel" :model="editModel" :label-width="100" inline>
      <FormItem label="患者姓名">{{ editModel.patientName }}</FormItem>
      <FormItem label="性别">{{ convertSex }}</FormItem>
      <FormItem label="身份证号">{{ editModel.idCardNO }}</FormItem>
      <FormItem label="手机号">{{ editModel.telePhone }}</FormItem>
      <!-- <FormItem label="证件号">{{ editModel.identityID }}</FormItem>
      <FormItem label="邮箱">{{ editModel.email }}</FormItem>
      <FormItem label="医保号">{{ editModel.insuranceID }}</FormItem>
      <FormItem label="职业">{{ editModel.occupation }}</FormItem>
      <FormItem label="工作单位">{{ editModel.addressWork }}</FormItem>

      <FormItem label="最后更新时间">{{ editModel.lastUpdateDate }}</FormItem> -->
    </Form>
    <Timeline>
      <TimelineItem v-for="(item,index) in timeData" :key="index">
        <p class="time">报告时间：{{ item.reportDate }}</p>
        <div class="content">
          <p><span class="contenttitle">报告医生</span>：{{ item.reportDr }}</p>
          <p><span class="contenttitle">审核医生</span>：{{ item.verifyDr }}</p>
          <p><span class="contenttitle">影像所见</span>：{{ item.findings }}</p>
          <p>
            <span class="contenttitle">诊断结果</span>：{{ item.diagnosis }}
          </p>
        </div>
      </TimelineItem>
    </Timeline>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  data: function () {
    return {
      organParentName: "",
      timeData: [],
    };
  },
  computed: {
    convertSex() {
      switch (this.editModel.patientSex) {
        case "F":
          return "女";
        case "M":
          return "男";
        default:
          return "未知";
      }
    },
  },
  created: function () {
    this.editModel = this.currentData;
    var Current = this;
    this.$api
      .get(
        "/patient/GetReportPage?PatientInfoID=" + this.currentData.patientInfoID
      )
      .then((rsp) => {
        console.log(rsp);

        if (rsp.statusCode == "200") {
          var list = rsp.data.list;
          list.sort(function (a, b) {
            return Date.parse(b.reportDate) > Date.parse(a.reportDate) ? -1 : 1;
          });
          Current.timeData = list;

          //   this.$Message.success(rsp.msg);
        } else {
          this.$Message.success("初始化失败");
        }
      });
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
.time {
  font-size: 14px;
  font-weight: bold;
}
.content {
  padding-left: 5px;
}
.contenttitle {
  font-weight: bold;
}
</style>